import { render } from "./MyNotes.vue?vue&type=template&id=88cb8b94"
import script from "./MyNotes.vue?vue&type=script&lang=js"
export * from "./MyNotes.vue?vue&type=script&lang=js"

import "./MyNotes.vue?vue&type=style&index=0&id=88cb8b94&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__